// Guest rooms TIDY can only send text into. Mirrors how gotidy routes a host
// message (SharedInbox::SendMessage + ChatRoom#guest_conversation):
//   - SMS rooms (`type: 'proxy'`) carry a phone number segment (`guest_number-…`,
//     `phone_number-…`) and go out over SMS, files included.
//   - Direct guest rooms (`type: 'guest'`, keyed `customer_account_id-X,guest_id-Y`,
//     plus `guest_conversation_id-Z` once scoped per platform thread) are sent to
//     the guest's Airbnb/VRBO/Booking.com conversation, through
//     `guest_conversation_id` or, for older rooms, the `guest_id` fallback, and
//     the file is dropped. The key can't tell whether that fallback finds a
//     conversation, so every direct guest room is text only. Legacy
//     `guest_reservation_id` rooms have no SMS channel either.
//   - A guest with no room yet only gets an SMS room on the first send, when
//     gotidy can bind its guest number, so the first message is text only and
//     attach comes back once the room key arrives.
const DIRECT_GUEST_SEGMENTS = ['guest_id', 'guest_conversation_id', 'guest_reservation_id'];

export function isTextOnlyGuestChatRoom(chatRoomKey: string | null | undefined, isGuest = false): boolean {
  if (!chatRoomKey) {
    return isGuest;
  }
  const segmentNames = chatRoomKey.split(',').map((segment) => segment.split('-')[0]);
  if (segmentNames.some((name) => name.endsWith('number'))) {
    return false;
  }
  return segmentNames.some((name) => DIRECT_GUEST_SEGMENTS.includes(name));
}
